import { render } from "./BaseCartButton.vue?vue&type=template&id=6b81af46&scoped=true"
import script from "./BaseCartButton.vue?vue&type=script&lang=js"
export * from "./BaseCartButton.vue?vue&type=script&lang=js"

import "./BaseCartButton.vue?vue&type=style&index=0&id=6b81af46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b81af46"]])

export default __exports__